import { Modal, Space, Table, Tooltip, Input, Popconfirm, Select, Button, Card } from "antd";
import React from "react";
import { withRouter } from "../../components/withRouter";
import Header from "../../components/Header";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  UnorderedListOutlined,
  UserSwitchOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { openNotification } from "../../functions";
var moment = require("moment");

const { Option } = Select;

class Clients extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRole: false,
      clientName: "",
      clientId: 0,
      selectedRole: "1",
      clients: [],
      editClient: false,
      spheres: [],
      salesModal: false,
      sales: [],
    };
  }

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  setRole(rec) {
    this.setState({
      modalRole: true,
      clientName: rec.tgu_username,
      selectedRole: rec.tgu_role,
      clientId: rec.key,
    });
  }

  getSheres() {
    fetch(`https://bot.weddingchelny.ru/api/adm/spheres`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.getClients();
          this.setState({ spheres: res.data });
        }
      }
    });
  }

  getClients() {
    fetch(`https://bot.weddingchelny.ru/api/adm/clients`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ clients: res.data, editClient: false });
        }
      }
    });
  }

  changeRole() {
    fetch(`https://bot.weddingchelny.ru/api/adm/clients/` + this.state.clientId + "/role", {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "PATCH",
      body: JSON.stringify({
        role: this.state.selectedRole,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({
            modalRole: false,
            clientName: "",
            selectedRole: "1",
            clientId: 0,
          });
          this.getClients();
        }
      }
    });
  }

  changeStatus(id, value) {
    fetch(`https://bot.weddingchelny.ru/api/adm/clients/` + id + "/status", {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "PATCH",
      body: JSON.stringify({
        status: value,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.getClients();
        }
      }
    });
  }

  getClientSales(id) {
    fetch(`https://bot.weddingchelny.ru/api/adm/clients/` + id + "/sales", {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({
            sales: res.data,
            salesModal: true,
          });
        }
      }
    });
  }

  render() {
    const columns = [
      {
        title: "Никнейм telegram",
        dataIndex: "tgu_username",
        key: "tgu_username",
      },
      {
        title: "Имя",
        dataIndex: "tgu_name_user",
        key: "tgu_name_user",
      },
      {
        title: "Телефон",
        dataIndex: "tgu_phone",
        key: "tgu_phone",
      },
      {
        title: "Баланс",
        dataIndex: "balans",
        key: "balans",
      },
      {
        title: "Нужно сменить роль на",
        dataIndex: "need_role",
        key: "need_role",
        render: (text, record) => {
          return this.state.spheres.length === 0
            ? ""
            : this.state.spheres.find((item) => item.id === record.need_role)?.name || "Не нужно";
        },
        sorter: (a, b) => a.need_role - b.need_role,
      },
      {
        title: "Роль",
        dataIndex: "tgu_role",
        key: "tgu_role",
        render: (text, record) => {
          return this.state.spheres.length === 0
            ? ""
            : this.state.spheres.find((item) => item.id === record.tgu_role)?.name || "Не нужно";
        },
      },
      {
        title: "Действия",
        dataIndex: "events",
        key: "events",
        render: (text, record) => {
          return (
            <Space size="large">
              <Tooltip title="Список покупок">
                <UnorderedListOutlined
                  onClick={() => {
                    this.getClientSales(record.key);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
              {record.tgu_status == 1 ? (
                <Popconfirm
                  title="Защита от случайного нажатия"
                  description="Вы действительно хотите заблокировать клиента?"
                  onConfirm={() => {
                    this.changeStatus(record.key, 0);
                  }}
                  onCancel={() => { }}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Tooltip title="Активен">
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  </Tooltip>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="Защита от случайного нажатия"
                  description="Вы действительно хотите разблокировать клиента?"
                  onConfirm={() => {
                    this.changeStatus(record.key, 1);
                  }}
                  onCancel={() => { }}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Tooltip title="Заблокирован">
                    <CloseCircleTwoTone twoToneColor="#eb2f96" />
                  </Tooltip>
                </Popconfirm>
              )}
              <Tooltip title="Изменить роль">
                <UserSwitchOutlined
                  onClick={() => {
                    this.setRole(record);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </Space>
          );
        },
      },
    ];

    return (
      <div>
        <Header />
        <div className="container">
          <Space>
            <h1>Клиенты</h1>
            <Tooltip title="Обновить данные">
              <Button
                onClick={() => {
                  this.getClients();
                }}
              >
                <ReloadOutlined />
              </Button>
            </Tooltip>
          </Space>
          {window.innerWidth > 650 ? (
            <Table columns={columns} dataSource={this.state.clients} />
          ) : (
            this.state.clients.map((record) => {
              return (
                <div className="sale_item">
                  <div>Никнейм telegram: {record.tgu_username}</div>
                  <div>Имя: {record.tgu_name_user}</div>
                  <div>Баланс: {record.balans}</div>
                  <div>Роль: {record.tgu_role == "2" ? "Партнер" : "Клиент"}</div>
                  <div>
                    Действия:
                    <br />
                    <Space direction="vertical">
                      <button
                        onClick={() => {
                          this.getClientSales(record.key);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <UnorderedListOutlined />
                        Список покупок
                      </button>
                      {record.tgu_status == 1 ? (
                        <Popconfirm
                          title="Защита от случайного нажатия"
                          description="Вы действительно хотите заблокировать клиента?"
                          onConfirm={() => {
                            this.changeStatus(record.key, 0);
                          }}
                          onCancel={() => { }}
                          okText="Да"
                          cancelText="Нет"
                        >
                          <button>
                            <CheckCircleTwoTone twoToneColor="#52c41a" />
                            Активен
                          </button>
                        </Popconfirm>
                      ) : (
                        <Popconfirm
                          title="Защита от случайного нажатия"
                          description="Вы действительно хотите разблокировать клиента?"
                          onConfirm={() => {
                            this.changeStatus(record.key, 1);
                          }}
                          onCancel={() => { }}
                          okText="Да"
                          cancelText="Нет"
                        >
                          <button>
                            <CloseCircleTwoTone twoToneColor="#eb2f96" />
                            Заблокирован
                          </button>
                        </Popconfirm>
                      )}
                      <button
                        onClick={() => {
                          this.setRole(record);
                        }}
                      >
                        <UserSwitchOutlined style={{ cursor: "pointer" }} />
                        Изменить роль
                      </button>
                    </Space>
                  </div>
                </div>
              );
            })
          )}

          <Modal
            title={"Изменение роли " + this.state.clientName}
            open={this.state.modalRole}
            onOk={() => {
              this.changeRole();
            }}
            onCancel={() => {
              this.setState({ modalRole: false });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            <Space>
              <p>Роль</p>
              <Select
                value={this.state.selectedRole}
                style={{ width: 200 }}
                onChange={(val) => {
                  this.setState({ selectedRole: val });
                }}
                placeholder="Выберите роль"
              >
                {this.state.spheres.map((elem, index) => {
                  return (
                    <Option key={"role_Select_optin" + index} value={elem.id}>
                      {elem.name}
                    </Option>
                  );
                })}
              </Select>
            </Space>
          </Modal>

          <Modal
            title={this.state.sales.length == 0 ? "Продажи" : "Продажи|" + this.state.sales.length}
            open={this.state.salesModal}
            onCancel={() => {
              this.setState({ salesModal: false });
            }}
            footer={[]}
          >
            <Space style={{ width: "100%" }} direction="vertical">
              {this.state.sales.length == 0
                ? ""
                : this.state.sales.map((sale, index) => {
                  return (
                    <Card
                      style={{ width: "100%" }}
                      title={moment(sale.sale_date).format("DD.MM.YYYY HH:mm")}
                      key={"sal_" + index}
                    >
                      <div>
                        Продавец: {sale.saler_surname} {sale.saler_name}
                      </div>
                      <div>
                        Партнер: {sale.partner_name} {sale.partner_username}
                      </div>
                      <b>Сумма: {sale.full_price}</b>
                      <div>
                        Товары:{" "}
                        {sale.products.map((prod, ind) => {
                          return (
                            <div
                              style={{ borderRadius: 16, background: "#efefef", padding: 10 }}
                              key={"prod_" + ind + "_" + index}
                            >
                              Наименование: {prod.name}
                              <br />
                              Количество: {prod.count}
                              <br />
                              Цена: {prod.price}
                              <br />
                              Сумма за товар: <b>{Number.parseFloat(prod.price).toFixed(2) * prod.count}</b>
                            </div>
                          );
                        })}
                      </div>
                    </Card>
                  );
                })}
            </Space>
          </Modal>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.getSheres();
  }
}

export default withRouter(Clients);
